import { Component, inject, signal } from '@angular/core';
import { version } from '../version';
import { HttpClient } from '@angular/common/http';
import { environment } from '../environment';

@Component({
  selector: 'app-footer',
  standalone: true,
  template: ` <footer class="footer">
    <div>© {{ year }} - Hospital LogiServe GmbH - Version Design: {{ buildDate }} - Version API: {{ apidate() }}</div>
  </footer>`,
})
export class FooterComponent {
  buildDate = version.buildDate;
  year = new Date().getFullYear();

  apidate = signal<string>('');
  private httpClient = inject(HttpClient);

  constructor() {
    this.httpClient.get<string>(environment.baseUrl() + 'system/version').subscribe({
      next: (response) => {
        this.apidate.set(response);
      },
      error: (err) => {
        //  console.log('Error: ' + err.message);
      },
    });
  }
}
